import { Carousel, Checkbox, Dropdown, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import { noop } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'shared/lib';
import { FilterTag } from 'shared/ui/FilterTag';

import type { TFilterAlias } from 'entities/vitrinsFilters';
import { selectAllVitrinsFilterFields } from 'entities/vitrinsFilters/model/vitrinsFiltersSlice.selector';

import { applyFilter } from 'features/VitrinsFilters';
import { VITRINS_FILTERS_DROPDOWN_TEXTS } from 'features/VitrinsFilters/ui/VitrinsFilters.texts';

type selectFilterArg = { alias: TFilterAlias; name: string; value: string };

type Props = {
  isGrayBackground?: boolean;
  onChangeFilter?: (arg: selectFilterArg) => void;
};

export const VitrinsFilters: FC<Props> = (props) => {
  const { isGrayBackground, onChangeFilter } = props;
  const isMobile = useIsMobile();
  const filters = useAppSelector(selectAllVitrinsFilterFields);
  const dispatch = useDispatch();

  const selectFilter = ({ alias, name, value }: selectFilterArg) => {
    onChangeFilter?.({ alias, name, value });
    dispatch(applyFilter({ alias, value }));
  };

  return (
    <Space
      direction="vertical"
      size={isMobile ? 16 : 24}
    >
      <Space
        wrap
        direction="horizontal"
        size={8}
      >
        <Carousel>
          {filters.map(({ selected, name, value, alias }) => (
            <FilterTag
              key={name}
              value={name}
              onClick={() => selectFilter({ alias, name, value })}
              isActive={selected}
              background={isGrayBackground ? 'dark' : 'light'}
            />
          ))}
        </Carousel>
      </Space>

      <Dropdown
        defaultValue={[2]}
        mode="multiple"
        onChange={noop}
        onClose={noop}
        onOpen={noop}
        options={[
          {
            control: <Checkbox />,
            label: VITRINS_FILTERS_DROPDOWN_TEXTS.POPULAR,
            value: 0,
          },
          {
            control: <Checkbox />,
            label: VITRINS_FILTERS_DROPDOWN_TEXTS.RATE,
            value: 1,
          },
          {
            control: <Checkbox />,
            label: VITRINS_FILTERS_DROPDOWN_TEXTS.SUM_UP,
            value: 2,
          },
          {
            control: <Checkbox />,
            label: VITRINS_FILTERS_DROPDOWN_TEXTS.SUM_DOWN,
            value: 3,
          },
        ]}
      />
    </Space>
  );
};
